import { h, Host } from "@stencil/core";
import { getSuggestions } from "./get-suggestions";
import { getUniqueId } from "../../utils/unique-id";
import { escapeRegexCharacters } from "../../utils/escapeRegexCharacters";
export class AutosuggestInput {
    constructor() {
        this.placeholder = "";
        this.name = "";
        this.inputId = "";
        this.label = "";
        this.labelInfo = "";
        this.url = "";
        this.disabled = false;
        this.required = false;
        this.error = false;
        this.errorMsg = null;
        this.staticSuggestions = [];
        this.suggestions = [];
        this.input = "";
        this.isHidden = true;
        this.id = "";
        this.hasStaticSuggestions = false;
    }
    inputElement;
    effectiveInputElement;
    domNode;
    componentWillLoad() {
        const { inputId } = this;
        this.id = inputId || getUniqueId();
    }
    componentDidLoad() {
        this.setHasStaticSuggestionsState();
    }
    setHasStaticSuggestionsState() {
        if (this.staticSuggestions.length === 0) {
            return;
        }
        const checkSuggestions = [...this.staticSuggestions];
        if (checkSuggestions.filter((staticSuggestion) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            staticSuggestion.description !== undefined;
        }).length === 0) {
            this.hasStaticSuggestions = true;
        }
    }
    onInput(event) {
        const { value } = event.target;
        this.input = value;
        if (this.staticSuggestions.length) {
            const suggestionValue = this.getValueFromSuggestion(value);
            this.effectiveInputElement.value = suggestionValue || value;
            if (value === "") {
                this.suggestions = this.staticSuggestions;
            }
            this.suggestions = this.filterStaticSuggestions(value);
            return;
        }
        if (value === "" || this.url === "") {
            this.suggestions = [];
            return;
        }
        getSuggestions(`${this.url}?q=${value}`)
            // @ts-expect-error Check for typing
            .then((response) => (this.suggestions = response))
            // eslint-disable-next-line no-console
            .catch((error) => console.error(error));
    }
    filterStaticSuggestions = (value) => {
        return this.staticSuggestions.filter((staticSuggestion) => (staticSuggestion.label || staticSuggestion.value).toLowerCase().includes(value.toLowerCase()));
    };
    getValueFromSuggestion = (value) => {
        const suggestion = this.staticSuggestions.find(
        // @ts-expect-error Check for typing
        (suggestion) => (suggestion.label.toLowerCase() || suggestion.value.toLowerCase()) === value.toLowerCase().trim());
        if (suggestion !== undefined) {
            return suggestion.value;
        }
        else {
            return null;
        }
    };
    onBlur() {
        this.isHidden = true;
    }
    onFocus() {
        this.isHidden = false;
        this.input = this.inputElement.value;
        if (this.staticSuggestions.length) {
            if (this.inputElement.value === "") {
                this.suggestions = this.staticSuggestions;
            }
            this.suggestions = this.filterStaticSuggestions(this.inputElement.value);
            return;
        }
    }
    onSuggestionItemClick(event, value) {
        event.preventDefault();
        this.inputElement.value = value;
        if (this.hasStaticSuggestions) {
            const suggestionItem = this.staticSuggestions.find((suggestion) => {
                return suggestion.value === value;
            });
            // @ts-expect-error Check for typing
            this.inputElement.value = suggestionItem.label;
            // @ts-expect-error Check for typing
            this.effectiveInputElement.value = suggestionItem.value;
        }
        this.suggestions = [];
    }
    getPatternAttribute = () => {
        if (!this.staticSuggestions.length) {
            return null;
        }
        return `^(${this.staticSuggestions.map((suggestion) => escapeRegexCharacters(suggestion.value)).join("|")})$`;
    };
    render() {
        const baseClass = "ux-autosuggest-input";
        const { placeholder, name, suggestions, id, input, label, labelInfo, isHidden, disabled, required, error, errorMsg, hasStaticSuggestions } = this;
        return (h(Host, { key: '8c18b565fff69fe8cbc88ed56f31a7916e6d6f8f', class: {
                [baseClass]: true,
                [`${baseClass}--disabled`]: disabled,
                [`${baseClass}--error`]: error
            }, onFocusout: () => this.onBlur() }, h("ux-input-label", { key: 'c502fe75dc11284fb7935d42d20ec0497d73cc27', text: label, inputId: id, error: error,
            // @ts-expect-error Check for typing
            errorMsg: errorMsg, required: required, labelInfo: labelInfo }), h("div", { key: '1b2d520216ac2dd4e9b7bbeca933813e7fe7576c', class: `${baseClass}__input-container` }, hasStaticSuggestions && (h("input", { key: '24b64cc6a84823f48894bc42e01028200203301f', name: name, type: "text", style: { display: "none" }, required: required,
            // @ts-expect-error Check for typing
            pattern: this.getPatternAttribute(),
            // @ts-expect-error Check for typing
            ref: (el) => (this.effectiveInputElement = el), "aria-hidden": "true" })), h("input", { key: '4ef4f00eccb550a092cf7f9e9d3f1441c147755f', class: "ux-input",
            // @ts-expect-error Check for typing
            name: hasStaticSuggestions ? null : name, type: "text", placeholder: placeholder, autocomplete: "off", autocapitalize: "off", id: id, disabled: disabled,
            // @ts-expect-error Check for typing
            required: hasStaticSuggestions ? null : required, onInput: (event) => this.onInput(event), onFocus: () => this.onFocus(),
            // @ts-expect-error Check for typing
            ref: (el) => (this.inputElement = el) }), h("div", { key: '9581492d28d56f170778f3031094cc117ea4c3d6', class: {
                [`${baseClass}__suggestions`]: true,
                [`${baseClass}__suggestions--hidden`]: isHidden || this.suggestions.length === 0,
                [`${baseClass}__suggestions--slim`]: this.hasStaticSuggestions
            } }, suggestions?.map(({ value, description, image, label: suggestionLabel }) => (h("a", { class: `${baseClass}__suggestion-link`, href: "#", onFocus: () => this.onFocus(), onClick: (event) => this.onSuggestionItemClick(event, value) }, h("ux-autosuggest-item", { text: !hasStaticSuggestions ? value : suggestionLabel, input: input, subline: description, image: image, slim: hasStaticSuggestions }))))))));
    }
    static get is() { return "ux-autosuggest-input"; }
    static get originalStyleUrls() {
        return {
            "$": ["autosuggest-input.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["autosuggest-input.css"]
        };
    }
    static get properties() {
        return {
            "placeholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "placeholder text for input"
                },
                "attribute": "placeholder",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "name attribute for input"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "inputId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "id attribute for input. A unique id will be generated if this is empty"
                },
                "attribute": "input-id",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "label for input"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "labelInfo": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "additional info label for the input field"
                },
                "attribute": "label-info",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "url": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "URL for autosuggest-API"
                },
                "attribute": "url",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the autosuggest input is disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the autosuggest input is required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the autosuggest input has an error"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Error message that is rendered if component has an error"
                },
                "attribute": "error-msg",
                "reflect": false,
                "defaultValue": "null"
            },
            "staticSuggestions": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "AutosuggestItem[]",
                    "resolved": "AutosuggestItem[]",
                    "references": {
                        "AutosuggestItem": {
                            "location": "import",
                            "path": "./autosuggest-response",
                            "id": "src/components/autosuggest-input/autosuggest-response.ts::AutosuggestItem"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "suggestions set statically, without an api request"
                },
                "defaultValue": "[]"
            }
        };
    }
    static get states() {
        return {
            "suggestions": {},
            "input": {},
            "isHidden": {},
            "id": {},
            "hasStaticSuggestions": {}
        };
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "inputId",
                "methodName": "componentWillLoad"
            }, {
                "propName": "staticSuggestions",
                "methodName": "setHasStaticSuggestionsState"
            }];
    }
}
//# sourceMappingURL=autosuggest-input.js.map
